/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/

// Replace all instances of "Flax Home" with "Wilet"
document.body.innerHTML = document.body.innerHTML.replace(/Flax Home/g, 'Wilet');
document.body.innerHTML = document.body.innerHTML.replace(/Flax Sleep/g, 'Wilet');

(function (AOS, FlickityFade, bodyScrollLock, Flickity, Sqrl, MicroModal, axios, Rellax, themeCurrency, themeAddresses, FlickitySync) {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  document.addEventListener('DOMContentLoaded', function () {
    // Check if URL has variant parameter
    var urlParams = new URLSearchParams(window.location.search);
    const url = window.location.href;

    let btnAddToCart = document.querySelector(".btn--add-to-cart .btn-state-ready [data-add-to-cart-text]");
    if (btnAddToCart) {
      btnAddToCart.textContent = "Add to Cart";
      pdpModalDisable();
    }

    // const setOfVariants = document.querySelector('.radio__inputs .radio__button input[name="options[Set]"]');
    let btnAddToCart2 = document.querySelector(".btn--add-to-cart .btn-state-ready [data-add-to-cart-text]");
    // Variant parameter exists, trigger the event
    var colorVariantSelected = document.querySelector('.swatch__button input:checked');
    var colorVariantSelectedValue = colorVariantSelected.value;
    if (colorVariantSelected) {
      var text = colorVariantSelectedValue;
      changeTextAddCartButton(btnAddToCart2);
      if (Array.from(document.querySelectorAll('.media__thumb')).length > 0) {
        handleCarousel(text);
      }

      if (colorVariantSelected.classList.contains('sold-out')) {
        document.querySelector('.variant__countdown--sold_out_message').classList.remove('hide');
        document.querySelector('.variant__countdown--inventory_message').classList.add('hide');
      }
    }

    if (url.includes('/collections')) {
      setUrlProductVariant();
    }

  });

  function pdpModalDisable() {
    const modalClose = document.querySelector('.pswp__button--close');
    const modalContainer = document.querySelector('.pswp');

    modalClose.addEventListener('click', function () {
      setTimeout(function () {
        modalContainer.classList.remove('pswp--open');
      }, 1000);
    });

    modalContainer.addEventListener('click', function () {
      if (document.querySelector('.pswp__ui').classList.contains('pswp__ui--over-close')) {
        setTimeout(function () {
          modalContainer.classList.remove('pswp--open');
        }, 1000);
      } else {
        return;
      }
    });
  }

  function bundlesPriceChange() {
    const bundleButtons = document.querySelectorAll('.bundle__button');

    bundleButtons.forEach(function (button, index) {
      button.addEventListener('click', function () {
        const gridIndexItem = document.getElementsByClassName('bundle-price')[index];
        const originalPrice = gridIndexItem.getAttribute('data-compare-bundle-price');
        const discountedPrice = gridIndexItem.getAttribute('data-bundle-price');

        document.querySelector('.discounted-price').innerHTML = discountedPrice;
        document.querySelector('.original-price').innerHTML = originalPrice;
      })
    })
  }

  function bundlesButtonActions() {
    const bundleButtons = document.querySelectorAll('.bundle__button');
    const firstBundleButton = document.querySelector('.bundle__button input');
    const includesSpan = document.querySelector('.bundles__includes');
    let bundleProductTitle = document.querySelector('.selected__bundle');
    let checkIcons = document.querySelectorAll('.bundle__button .check-icon');
    let bundleProductLink = document.querySelector('.to__bundle__product');

    setTimeout(function () { firstBundleButton.click(); }, 100);

    bundleButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        checkIcons.forEach(function (icon) {
          icon.classList.remove('show');
          icon.classList.add('hide');
        })
        const selectedBundleProduct = button.getAttribute('data-bundle-product');
        const selectedBundleIncludes = button.getAttribute('data-includes');

        let selectedCheckIcon = document.querySelector(`[data-bundle-product="${selectedBundleProduct}"] .check-icon`);
        selectedCheckIcon.classList.remove('hide');
        selectedCheckIcon.classList.add('show');
        bundleProductTitle.innerHTML = selectedBundleProduct;

        includesSpan.innerHTML = selectedBundleIncludes;

        //Set URL to button
        const selectedBundleProductUrl = button.getAttribute('data-product-url');
        bundleProductLink.href = `${selectedBundleProductUrl}`;
      })
    })
  }

  if (document.getElementById('bundles')) {
    bundlesButtonActions();
    bundlesPriceChange();
  }


  function handleImagesModal(variant) {
    let $carouselModal = document.querySelector('.quickview__modal__images');

    async function removingFlicktyCells(featuredImages, carousel) {
      featuredImages.forEach(function (element) {
        element.remove();
      });
    }

    async function addingImagesModal(carousel) {
      let featuredImages = document.querySelectorAll('.quickview__modal__images .product__media');

      let imagesContainer = document.querySelector('.media__thumb__wrapper');
      let sliderCloneContainer = document.querySelector('.product__grid--clone');

      for (let i = 0; i < imagesContainer.children.length; i++) {
        const imageElement = imagesContainer.children[i];
        const imageElementVariant = imageElement.getAttribute('aria-label');

        const sliderCloneContainerChildrens = sliderCloneContainer.children[i];

        if (imageElementVariant == variant) {
          hasThumbnailImages = true;
          removingFlicktyCells(featuredImages, carousel);
          sliderCloneContainerChildrens.classList.remove('product__media--clone');
          sliderCloneContainerChildrens.classList.add('product__media');
          const newFeaturedElements = sliderCloneContainerChildrens.cloneNode(true);
          carousel.appendChild(newFeaturedElements);
        }
      }
    }

    async function changeSliderImagesPdp() {
      addingImagesModal($carouselModal);
    }

    if (document.querySelector('.template-product')) {
      changeSliderImagesPdp();
    }
  }

  function handleCarousel(variant) {
    sessionStorage.setItem('refreshCarousel', 'true');
    let carouselContainer = document.querySelector('.product__grid--slides');
    let $carousel = new Flickity(carouselContainer);

    $carousel.selectCell(0);

    async function removingFlicktyCells(featuredImages, carousel) {
      featuredImages.forEach(function (element) {
        carousel.remove(element);
      });
    }

    async function addingFlicktyCells(carousel) {
      let hasThumbnailImages = false;
      let hasThumbnailImagesAux = 0;
      let featuredImages = document.querySelectorAll('.flickity-slider .product__media');

      let imagesContainer = document.querySelector('.media__thumb__wrapper');
      let sliderCloneContainer = document.querySelector('.product__grid--clone');

      for (let i = 0; i < imagesContainer.children.length; i++) {
        const imageElement = imagesContainer.children[i];
        const imageElementVariant = imageElement.getAttribute('aria-label');

        const sliderCloneContainerChildrens = sliderCloneContainer.children[i];

        if (imageElementVariant == variant) {
          hasThumbnailImages = true;
          sessionStorage.setItem('refreshCarousel', 'false');
          removingFlicktyCells(featuredImages, carousel);
          imageElement.style.display = "inline-block";
          sliderCloneContainerChildrens.classList.remove('product__media--clone');
          sliderCloneContainerChildrens.classList.add('product__media');
          const newFeaturedElements = sliderCloneContainerChildrens.cloneNode(true);
          carousel.append(newFeaturedElements);
        }

        if (hasThumbnailImages === false) {
          hasThumbnailImagesAux = hasThumbnailImagesAux + 1;
        }
      }

      setTimeout(() => {
        var value = sessionStorage.getItem('refreshCarousel');
        if (value === 'true') {
          return;
        }
      }, "500");
    }

    async function changeSliderImagesPdp() {
      const imagesContainerAll = document.querySelectorAll('.media__thumb__wrapper .media__thumb');
      imagesContainerAll.forEach(function (element) {
        element.style.display = "none";
      });

      addingFlicktyCells($carousel);
    }

    if (document.querySelector('.template-product')) {
      changeSliderImagesPdp();
    }

    $carousel.selectCell(0);
  }



  // This function management product variants url in collection pages
  function setUrlProductVariant() {
    // Set the product variant url in product when click in variant colors
    let variantElement = document.querySelectorAll('.swatch__button .swatch__label');
    variantElement.forEach(function (variant) {
      variant.addEventListener("click", function (element) {
        let variantClicked = element.target;
        let variantHref = variantClicked.getAttribute('href');
        let variantID = variantClicked.getAttribute("data-grid-item-variant");
        let variantProductLink = searchParentElement(variantClicked, 'product-grid-item').querySelector('[data-grid-item-variant-id="' + variantID + '"]');
        variantProductLink.href = variantHref;
      })
    })


    // Set the first product variant url in product when load page
    if (!window.location.href.includes('filter.v.option.colour')) {
      let variantContainer = document.querySelectorAll('.grid__swatch__hover');
      variantContainer.forEach(function (variant) {
        let variantFirstOption = variant.querySelector('.swatch__label');
        let variantHref = variantFirstOption.getAttribute('href');
        variantFirstOption.setAttribute('aria-label', 'true');
        let variantProductLink = searchParentElement(variantFirstOption, 'product-grid-item').querySelector('[data-grid-link]');
        variantProductLink.href = variantHref;
        variantFirstOption.click();
      })
    }
  }

  // This function search parent element
  function searchParentElement(elm, className) {
    let element = elm;
    let parent = element.parentNode;

    while (parent !== null) {
      if (parent.classList.contains(className)) {
        return parent;
      }
      parent = parent.parentNode;
    }
  }

  function changeTextAddCartButton(btnAddToCart, variant, eventWrapper) {
    let SelectedVariant = '';
    if (variant != undefined) {
      let arrayVariants = document.querySelectorAll('.radio__legend__label');
      let countVariants = arrayVariants.length;
      if (arrayVariants[countVariants - 1].textContent === 'Colour') {
        if (arrayVariants.length > 1) {
          SelectedVariant = document.querySelector('[data-swatch-input][value="' + variant.option2 + '"][data-option-parent="' + variant.option1 + '"]');
        } else {
          SelectedVariant = document.querySelector('[data-swatch-input][value="' + variant.option1 + '"]');
        }
      } else {
        SelectedVariant = document.querySelector('[value="' + variant.option1 + '"]');
      }

      let InventoryMessageVariant = document.querySelector(".variant__countdown--inventory_message");
      if (eventWrapper.includes('quickview__modal')) {
        InventoryMessageVariant = document.getElementsByClassName("variant__countdown--inventory_message")[1];
      }

      let preOrderElement = SelectedVariant?.getAttribute("data-pre-order");
      let InputHiddenPreOrderItemCartProperty = document.querySelector("[data-product-preorder]");
      let InputHiddenInventoryMsgItemCartProperty = document.querySelectorAll("[data-product-inventory-message]");
      let containerBtnAddToCart = document.querySelector('.btn--add-to-cart');
      let buttonTextAddToCart = SelectedVariant?.getAttribute("data-button-text");
      let buttonTextKlaviyoBis = SelectedVariant?.getAttribute("data-button-text-klaviyo-bis");
      let SoldOutMessageVariant = document.querySelector(".variant__countdown--sold_out_message");

      InputHiddenPreOrderItemCartProperty.value = false;
      containerBtnAddToCart.disabled = false;

      if (InventoryMessageVariant) {
        InventoryMessageVariant.textContent = SelectedVariant?.getAttribute("data-inventory-message");
        InputHiddenInventoryMsgItemCartProperty.forEach(function (element) {
          if (SelectedVariant?.getAttribute("data-inventory-message") !== undefined) {
            element.value = SelectedVariant?.getAttribute("data-inventory-message");
          }
        })
      }

      if (SoldOutMessageVariant) {
        SoldOutMessageVariant.textContent = SelectedVariant?.getAttribute("data-sold-out-message");
      }

      if (buttonTextKlaviyoBis != '' && document.querySelector('.klaviyo-bis-trigger')) {
        setTimeout(() => {
          document.querySelector('.klaviyo-bis-trigger').textContent = buttonTextKlaviyoBis;
        }, 1000);
      }

      if (SelectedVariant?.classList.contains("sold-out")) {
        InventoryMessageVariant.classList.add('hide');
        SoldOutMessageVariant.classList.remove('hide');
        if (buttonTextAddToCart != '') {
          btnAddToCart.textContent = buttonTextAddToCart;
          containerBtnAddToCart.disabled = true;
        } else {
          btnAddToCart.textContent = "Sold out";
          containerBtnAddToCart.disabled = true;
        }
      } else {
        InventoryMessageVariant.classList.remove('hide');
        SoldOutMessageVariant.classList.add('hide');
        if (preOrderElement === "true") {
          btnAddToCart.textContent = "Pre-order";
          InputHiddenPreOrderItemCartProperty.value = true;
        } else {
          btnAddToCart.textContent = "Add to Cart";
        }
      }


    } if (variant == undefined && document.querySelector('.swatch__button input').checked) {
      document.querySelector('.swatch__button input').checked = false;
      document.querySelector('.swatch__button input').click();
      document.querySelector('.swatch__button input').checked = true;
    } else {
      return;
    }
  };

  function getAllOptions() {
    return Array.from(document.querySelectorAll('.radio__legend__label')).map(item => item.textContent.toLowerCase());
  }

  document.addEventListener('theme:variant:change', async function (event) {

    let eventOuterWrapper = event.target.container.outerWrapper.className;

    if (event.target.quickview === null) {
      let btnAddToCart = document.querySelector(".btn--add-to-cart .btn-state-ready [data-add-to-cart-text]");

      if (getAllOptions().includes('denomination')) {
        btnAddToCart.innerHTML = 'Add to Cart';
      }

      var variant = event.detail.variant;
      if (variant) {
        if (!getAllOptions().includes('denomination')) {
          // SetTimeout to force a new cyclelife to get a current variant selected
          setTimeout(() => {
            changeTextAddCartButton(btnAddToCart, variant, eventOuterWrapper);
          }, 100)
        }
        if (Array.from(document.querySelectorAll('.media__thumb')).length > 0) {
          handleCarousel(variant.option2 ? variant.option2 : variant.option1);
        }
      }
    }

    if (eventOuterWrapper.includes('quickview__modal')) {
      var quickviewElement = document.querySelector('[data-popup-api-product-quickview]');
      var sizeElement = document.getElementById('size-api-product-quickview');

      // Add click event listener to the quickview element
      quickviewElement.addEventListener('click', function () {
        // Toggle the is-open class on the size element
        sizeElement.classList.toggle('is-open');
        sizeElement.setAttribute('aria-hidden', 'false');

        //Meters Table
        let cmMeter = sizeElement.querySelectorAll('.meter-cm');
        let inMeter = sizeElement.querySelectorAll('.meter-in');

        let inMeters = sizeElement.querySelectorAll('.pdp-inches-value');
        let cmMeters = sizeElement.querySelectorAll('.pdp-cm-value');

        let cmMeterSwap = sizeElement.getElementsByClassName('meter-cm')[0];
        let inMeterSwap = sizeElement.getElementsByClassName('meter-in')[0];

        cmMeter.forEach(function (meter) {
          meter.addEventListener("click", function () {
            inMeters.forEach(function (meter) {
              meter.classList.add('hidden-element');
              inMeterSwap.classList.remove('.meter-highlighted');
              inMeterSwap.classList.add('meter-opacity');
            })

            cmMeters.forEach(function (meter) {
              meter.classList.remove('hidden-element');
              cmMeterSwap.classList.remove('meter-opacity');
              cmMeterSwap.classList.add('meter-highlighted');
            })
          });
        })

        inMeter.forEach(function (meter) {
          meter.addEventListener("click", function () {
            inMeters.forEach(function (meter) {
              meter.classList.remove('hidden-element');
              inMeterSwap.classList.remove('meter-opacity');
              inMeterSwap.classList.add('meter-highlighted');
            })

            cmMeters.forEach(function (meter) {
              meter.classList.add('hidden-element');
              cmMeterSwap.classList.remove('meter-highlighted');
              cmMeterSwap.classList.add('meter-opacity');
            })
          });
        })
      });
      var variant = event.detail.variant;
      let btnAddToCart = document.querySelector(".quickview__modal .btn--add-to-cart .btn-state-ready [data-add-to-cart-text]");
      if (variant === null) {
        return;
      } else {
        changeTextAddCartButton(btnAddToCart, variant, eventOuterWrapper);
        handleImagesModal(variant.option2 ? variant.option2 : variant.option1);
      }
    }
  });

  function showStockToggle() {
    const cart_button = document.querySelector('.navlink--cart');
       
    const cart_items = document.querySelectorAll('.cart__items .cart__items__row');
    const instock_toggle = document.getElementById('instock-toggle');
    const shipInstockInput = document.getElementById('ship-instock-input');
    const checkbox = document.querySelector('input[name="toggle-instock"]');
    const cartDrawer = document.querySelector('.cart__drawer');

    let isItemInStock = false;
    let isItemPreOrder = false;

    cart_items.forEach(function(e, index){
      const product_quantity = e.getAttribute('data-variant-quantity');
      const isPreOrder = e.getAttribute('data-preorder-variant');
      
      if(cart_items.length > 1 && product_quantity > 0) {
        isItemInStock = true;
      }

      if(cart_items.length > 1 && isPreOrder == 'true' ) {
        isItemPreOrder = true;
      }
    });

    if(isItemInStock && isItemPreOrder) {
      if(document.getElementById('instock-toggle')) {
        instock_toggle.classList.remove('display-none');
        instock_toggle.classList.add('display-flex');

        // Add an event listener to the checkbox
        checkbox.addEventListener('change', function(event) {
          if (event.target.checked) {
            shipInstockInput.value = "Yes, ship in stock items.";
            localStorage.setItem('shipInStock', 'true');
          } else {
            shipInstockInput.value = "";
            localStorage.setItem('shipInStock', 'false');
          }
        });
      }
    } else {
      if(document.getElementById('instock-toggle')) {
        instock_toggle.classList.add('display-none');
        instock_toggle.classList.remove('display-flex');
        shipInstockInput.value = "";
        shipInstockInput.innerHTML = "";
        checkbox.checked = false;

        if(document.querySelector('.cart__drawer')){
          if(cartDrawer.classList.contains('drawer--visible')) {
            localStorage.removeItem('shipInStock');
          }
        }else if(document.querySelector('.cart__template')) {
          localStorage.removeItem('shipInStock');
        }
      }
    }

    if(localStorage.getItem('shipInStock') === 'true') {
      shipInstockInput.value = "Yes, ship in stock items.";
      checkbox.checked = true;
    }else {
      shipInstockInput.value = "";
      checkbox.checked = false;
      shipInstockInput.innerHTML = "";
    }

  }

  document.addEventListener('theme:cart:change', function (event) {
    var cart = event.detail.cart;
    if (cart) {
      //console.log('Cart ———————————— ↓');
      //console.log(cart);
      // ... update an app or a custom shipping calculator
      
      setTimeout(showStockToggle, 1000);
    }
  });

  if(document.querySelector('.drawer.cart__drawer')) {
    let drawer = document.querySelector('.drawer.cart__drawer');
  
    drawer.addEventListener('theme:drawer:open', function (event) {
      setTimeout(showStockToggle, 1000);
    });
  }


  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    //console.log('theme:cart:init');
    //console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  // document.addEventListener('theme:scroll', e => { console.log(e); });
  // document.addEventListener('theme:scroll:up', e => { console.log(e); });
  // document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  // document.addEventListener('theme:resize', e => { console.log(e); });

  if (document.querySelector('.template-product')) {
    let sliderClone = document.querySelectorAll('.product__grid--clone .product__media');
    sliderClone.forEach(function (element) {
      element.classList.add('product__media--clone');
      element.classList.remove('product__media');
    })

    //Meters Table
    let cmMeter = document.querySelectorAll('.meter-cm');
    let inMeter = document.querySelectorAll('.meter-in');

    let inMeters = document.querySelectorAll('.pdp-inches-value');
    let cmMeters = document.querySelectorAll('.pdp-cm-value');

    let cmMeterSwap = document.getElementsByClassName('meter-cm')[0];
    let inMeterSwap = document.getElementsByClassName('meter-in')[0];

    cmMeter.forEach(function (meter) {
      meter.addEventListener("click", function () {
        inMeters.forEach(function (meter) {
          meter.classList.add('hidden-element');
          inMeterSwap.classList.remove('.meter-highlighted');
          inMeterSwap.classList.add('meter-opacity');
        })

        cmMeters.forEach(function (meter) {
          meter.classList.remove('hidden-element');
          cmMeterSwap.classList.remove('meter-opacity');
          cmMeterSwap.classList.add('meter-highlighted');
        })
      });
    })

    inMeter.forEach(function (meter) {
      meter.addEventListener("click", function () {
        inMeters.forEach(function (meter) {
          meter.classList.remove('hidden-element');
          inMeterSwap.classList.remove('meter-opacity');
          inMeterSwap.classList.add('meter-highlighted');
        })

        cmMeters.forEach(function (meter) {
          meter.classList.add('hidden-element');
          cmMeterSwap.classList.remove('meter-highlighted');
          cmMeterSwap.classList.add('meter-opacity');
        })
      });
    })
  }

  function holidayCollectionBannerLocation() {
    const holidayBanner = document.querySelectorAll('.section--image--holiday');
    const collectionContainer = document.querySelector('.js-grid');
    const collectionContainerChildrens = collectionContainer.children;

    // Filter out elements with the class 'section--image--holiday'
    const nonHolidayChildren = Array.from(collectionContainerChildrens).filter(child => !child.classList.contains('section--image--holiday'));

    holidayBanner.forEach(function(banner) {
        const bannerLocation = parseInt(banner.getAttribute('data-collection-position'));
        if (!isNaN(bannerLocation) && bannerLocation > 0 && bannerLocation <= nonHolidayChildren.length) {
            const targetElement = nonHolidayChildren[bannerLocation - 1];

            // Get the height of the target element
            const targetHeight = targetElement.offsetHeight;

            // Set the height of the banner
            banner.style.height = `${targetHeight}px`;

            // Insert the banner into the collection container
            collectionContainer.insertBefore(banner, targetElement);
        } else if (bannerLocation >= nonHolidayChildren.length) {
          // Get the last non-holiday child
          const lastNonHolidayChild = nonHolidayChildren[nonHolidayChildren.length - 1];

          // Get the height of the last non-holiday child
          const lastNonHolidayChildHeight = lastNonHolidayChild.offsetHeight;

          // Set the height of the banner
          banner.style.height = `${lastNonHolidayChildHeight}px`;

          // Insert the banner into the collection container after the last non-holiday child
          collectionContainer.appendChild(banner);
        }
    });
}

  if(document.querySelector('.section--image--holiday')) {
    holidayCollectionBannerLocation();
  }

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the
  // scroll locking code knows what element should maintain scoll.
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));


  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})(themeVendor.AOS, themeVendor.FlickityFade, themeVendor.BodyScrollLock, themeVendor.Flickity, themeVendor.Sqrl, themeVendor.MicroModal, themeVendor.axios, themeVendor.Rellax, themeVendor.themeCurrency, themeVendor.themeAddresses, themeVendor.FlickitySync);